import { removeCharactersBetweenPlusAndAt, removePeriodsBeforeAt } from 'core/common/utils/email';
import { hash256 } from 'core/common/utils/hash';
import {
  removeAccents,
  removeLeadingTrailingPeriods,
  removeWhitespaces,
  toLowerCase,
} from 'core/common/utils/string';
import {
  BingAdsAddToCartParams,
  BingAdsCheckoutParams,
  BingAdsPurchaseParams,
} from '../../entities';
import { AppnebulaBingAdsService, BingAdsService } from '../../interfaces';

export class AppnebulaHttpBingAdsService implements AppnebulaBingAdsService {
  constructor(private readonly httpBingAdsService: BingAdsService) {}

  addToCart({ trialPrice, productId, email, currency, orderId }: BingAdsAddToCartParams): void {
    const data = {
      currency,
      ecomm_pagetype: 'product',
      ecomm_prodid: [orderId],
      ecomm_totalvalue: trialPrice,
      items: [
        {
          id: productId,
          price: trialPrice,
          quantity: 1,
        },
      ],
      pid: { em: this.prepareEmail(email) },
      revenue_value: trialPrice,
    };

    this.httpBingAdsService.track('add_to_cart', data);
  }

  beginCheckout({ trialPrice, productId, email, currency, orderId }: BingAdsCheckoutParams): void {
    const data = {
      currency,
      ecomm_pagetype: 'cart',
      ecomm_prodid: [orderId],
      ecomm_totalvalue: trialPrice,
      items: [
        {
          id: productId,
          quantity: 1,
          price: trialPrice,
        },
      ],
      pid: { em: this.prepareEmail(email) },
      revenue_value: trialPrice,
    };

    this.httpBingAdsService.track('begin_checkout', data);
  }

  purchase({
    price,
    productId,
    email,
    currency,
    orderId,
    ltvPredict,
  }: BingAdsPurchaseParams): void {
    const data = {
      currency,
      ecomm_pagetype: 'purchase',
      ecomm_prodid: [orderId],
      ecomm_totalvalue: ltvPredict,
      items: [
        {
          id: productId,
          price: price,
          quantity: 1,
        },
      ],
      pid: { em: this.prepareEmail(email) },
      revenue_value: ltvPredict,
      transaction_id: orderId,
    };

    this.httpBingAdsService.track('purchase', data);
  }

  private prepareEmail(email: string) {
    if (!email) return '';

    return [
      removeWhitespaces,
      toLowerCase,
      removeCharactersBetweenPlusAndAt,
      removePeriodsBeforeAt,
      removeLeadingTrailingPeriods,
      removeAccents,
      hash256,
    ].reduce((acc, fn) => fn(acc), email);
  }
}
